import { render, staticRenderFns } from "./OnlinePayV2.vue?vue&type=template&id=4bd9ecbe&scoped=true&"
import script from "./OnlinePayV2.vue?vue&type=script&lang=ts&"
export * from "./OnlinePayV2.vue?vue&type=script&lang=ts&"
import style0 from "./OnlinePayV2.vue?vue&type=style&index=0&id=4bd9ecbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd9ecbe",
  null
  
)

export default component.exports